import ApiClient from "api/apiClient"
import { AxiosInstance } from "axios";

class SchoolMergeAuthClient extends ApiClient{
  axiosInstance: AxiosInstance;

  constructor() {
    const baseUrl = process.env.REACT_APP_AUTH_SERVER;
    if (baseUrl) {
      super(baseUrl);

      this.client.defaults.withCredentials = true;
      this.axiosInstance = this.client;
    }
    else {
      throw new Error("REACT_APP_AUTH_SERVER not specified");
    }
  }
}

export const schoolMergeAuthClient = new SchoolMergeAuthClient();